import React from 'react';
import ReactDOM from 'react-dom';
//import HelloWorld from "./hello";
//import todos from './components/todos.json';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
//import NavigationExample from "./components/NavigationExample.js";
//import NavigationSidebar from "./components/a6/Build/NavigationSidebar";
//import WhoToFollowListItem from "./components/a6/Build/WhoToFollowList/WhoToFollowListItem";
//import WhoToFollowList from "./components/a6/Build/WhoToFollowList/WhoToFollowList";
//import ExploreScreen from "./components/a6/Build/ExploreScreen/ExploreScreen";
//import HomeScreen from "./components/a6/Build/HomeScreen/HomeScreen";
//import ExploreScreen from "./components/a6/Build/ExploreScreen/ExploreScreen";

ReactDOM.render(
    <App/>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();


